"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var functions_exports = {};
__export(functions_exports, {
  children: () => children,
  unsafePushChild: () => unsafePushChild
});
module.exports = __toCommonJS(functions_exports);
function children(node) {
  switch (node.type) {
    case "Text":
      return void 0;
    case "SoftBreak":
      return void 0;
    case "LineBreak":
      return void 0;
    case "Emph":
      return node.children;
    case "Strong":
      return node.children;
    case "HtmlInline":
      return void 0;
    case "Link":
      return void 0;
    case "Image":
      return void 0;
    case "Code":
      return void 0;
    case "Document":
      return node.children;
    case "Paragraph":
      return node.children;
    case "BlockQuote":
      return node.children;
    case "List":
      return node.children;
    case "Item":
      return node.children;
    case "Heading":
      return node.children;
    case "CodeBlock":
      return void 0;
    case "HtmlBlock":
      return void 0;
    case "ThematicBreak":
      return void 0;
    case "CustomInline":
      return void 0;
    case "CustomBlock":
      return void 0;
  }
}
function unsafePushChild(parent, child) {
  parent.children.push(child);
}
// Annotate the CommonJS export names for ESM import in node:
0 && (module.exports = {
  children,
  unsafePushChild
});
//# sourceMappingURL=functions.js.map
